import React, { useEffect, useState } from 'react'
import DeleteButton from '../../../../components/common/buttons/DeleteButton'
import SaveButton from '../../../../components/common/buttons/SaveButton'
import useInputs from '../../../../utils/hooks/useInputs'
import CenterService from '../../../../services/centers/center.service'
import ConventionsService from '../../../../services/settings/conventions/conventions.service'
import LabeledDropdown from '../../../../components/common/form-components/labeled-dropdown/LabeledDropdown'

const CenterConventionForm = ({ centerId, selectedItem, hide }) => {
  const { inputs, onChangeInputs, updateInputs } = useInputs()

  const [conventions, setConventions] = useState()

  useEffect(() => {
    getConventions()
    if (selectedItem) {
      updateInputs({
        conventionId: selectedItem?.conventionId,
      })
    } else {
      updateInputs({
        date: new Date(),
      })
    }
  }, [])

  const getConventions = async () => {
    const response = await ConventionsService.getAll({})
    if (response) {
      setConventions(response.resp)
    }
  }

  const handleSave = async () => {
    // console.log('handleSave')
    if (centerId && centerId !== 'undefined' && !selectedItem) {
      // console.log('inputs', inputs)
      const data = {
        ...inputs,
      }
      const response = await CenterService?.conventions?.create({
        id: centerId,
        body: data,
      })
      // console.log('response', response)
      if (response) {
        hide()
        // updateInputs(response?.resp)
      }
    }
  }

  const handleRemove = async () => {
    // console.log('handleSave')
    if (centerId && centerId !== 'undefined' && selectedItem) {
      // console.log('selectedItem', selectedItem)
      const data = {
        ...inputs,
      }
      const response = await CenterService?.conventions.remove({
        id: centerId,
        rowId: selectedItem?._id,
      })
      // console.log('response', response)
      if (response) {
        hide()
        // updateInputs(response?.resp)
      }
    }
  }

  return (
    <div className="center-form-content">
      <div className="wrapper-flex">
        <LabeledDropdown
          idLabel="convention"
          required
          name="conventionId"
          optionLabel="name"
          optionValue="_id"
          value={inputs?.conventionId}
          options={conventions}
          showClear
          onChange={onChangeInputs}
        />
      </div>

      <div className="wrapper-flex">
        <div className="modal-btn-container wrapper-flex">
          {selectedItem ? (
            <DeleteButton
              btnClass="btn-remove-modal"
              // isDisabled={!validateForm}
              onClick={handleRemove}
            />
          ) : (
            <SaveButton
              btnClass="btn-save-modal"
              // isDisabled={!validateForm}
              onClick={handleSave}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default CenterConventionForm
